module.exports = __webpack_public_path__ + "static/resume.e9d4b215.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/resume.pdf
// module id = 308
// module chunks = 156897593687669